import { postpro } from '../index';

export const uploadFile = data => {
  return postpro('/projects/preupload', data, false);
};

export const uploadFilePublic = data => {
  return postpro('/r2/upload', data, false);
};
